import AsignarDenuncia from './AsignarDenuncia';

export default AsignarDenuncia;
